var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.viewer, {
    tag: "Component",
    staticClass: "nft_payload_view",
    attrs: {
      "payload": _vm.payload
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }